import { NavLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { Exception } from '@/redux/slices/slice_types';

type ExceptionReferenceIdProps = {
  id?: Exception['reference_id'];
  type?: Exception['reference_type'];
};

const referenceLinksDictionary: Record<
  Exception['reference_type'],
  { url: (refId: Exception['reference_id']) => string; label: (refId: Exception['reference_id']) => string }
> = {
  order: {
    url: (refId: Exception['reference_id']) => `/orders?filters={"filter_id":["W${refId}","order_hid_filter"]}`,
    label: (refId: Exception['reference_id']) => `W${refId}`
  },
  job: {
    url: (refId: Exception['reference_id']) => `/jobs/${refId}`,
    label: (refId: Exception['reference_id']) => `J${refId}`
  },
  task: {
    url: (refId: Exception['reference_id']) => `/tasks/?id=${refId}`,
    label: (refId: Exception['reference_id']) => `T${refId}`
  },
  asset: {
    url: (refId: Exception['reference_id']) => `/pending-assets?filters={"filter_id":["A${refId}","job_asset_hid_filter"]}&page=1`,
    label: (refId: Exception['reference_id']) => `A${refId}`
  },
  ingest: {
    url: (refId: Exception['reference_id']) => `/ingest-management/${refId}`,
    label: (refId: Exception['reference_id']) => `R${refId}`
  }
};

const ExceptionReferenceId = ({ id, type }: ExceptionReferenceIdProps) => {
  if (!id || !type) return '-';
  if (!referenceLinksDictionary[type?.toLowerCase()]) return <>{id}</>;
  const referenceObject = referenceLinksDictionary[type?.toLowerCase()];
  return (
    <Link component={NavLink} to={referenceObject.url(id)} onClick={(e) => e.stopPropagation()}>
      {referenceObject.label(id)}
    </Link>
  );
};

export default ExceptionReferenceId;
